import { Component } from '@angular/core';
import { HTTPStatus } from '../../services/interceptor/HTTPStatus/httpstatus.service';
import { HTTPUtils } from '../../services/interceptor/HTTPUtils/httputils.service';
import { CompartilhadoService } from 'src/app/services/compartilhado/compartilhado.service';

@Component({
  selector: 'app-interceptor',
  templateUrl: './interceptor.component.html',
  styleUrls: ['./interceptor.component.scss']
})
export class InterceptorComponent {

  hide = true;
  timeout: any;
  contador = 0;
  frase = 'Carregando';

  constructor(
    private httpStatus: HTTPStatus,
    private httpUtils: HTTPUtils,
    public compartilhadoService: CompartilhadoService
  ) {

    this.httpUtils.Frase.subscribe(frase => this.frase = frase);
    this.httpUtils.Hide.subscribe(hide => this.hide = hide);

    this.httpStatus.getHttpStatus().subscribe((status: boolean) => {
      if (!status) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.httpUtils.forceUpdateHide(status);
        }, 50);
      } else {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.httpUtils.forceUpdateHide(true);
        }, 50);
      }
    });
  }

}
